<template>
  <div class="container-fluid py-3">
    <div class="d-flex align-items-center mb-3">
      <span class="mr-2" style="color:#8247E5; font-size:1.1rem; font-weight:700">Polygon</span>
      <h5 class="mb-0 mr-3">Transaction History</h5>
      <router-link to="/polygon" class="btn btn-sm btn-outline-secondary">← Wallet</router-link>
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="input-group input-group-sm">
          <input class="form-control" v-model="address" placeholder="0x…" @keyup.enter="load" />
          <div class="input-group-append">
            <button class="btn btn-sm" style="background:#8247E5;color:#fff" @click="load" :disabled="loading">
              {{ loading ? 'Loading…' : 'Load' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <TxTable :txs="txs" :loading="loading" accent-color="#8247E5" />
  </div>
</template>

<script>
import TxTable from '../components/TxTable.vue';
import { fetchEthTxs, fetchEthTokenTxs } from '../services/txService';

export default {
  name: 'PolygonTransactions',
  components: { TxTable },
  data() { return { address: '', txs: [], loading: false }; },
  methods: {
    async load() {
      if (!this.address.trim()) return;
      this.loading = true;
      try {
        const [native, tokens] = await Promise.all([
          fetchEthTxs(this.address.trim(), 1, 200, 137),
          fetchEthTokenTxs(this.address.trim(), 137),
        ]);
        this.txs = [...native, ...tokens].sort((a, b) => b.timestamp - a.timestamp);
      }
      catch (e) { alert('Error: ' + e.message); }
      finally { this.loading = false; }
    },
  },
  mounted() {
    const w = this.$store && this.$store.state.wallets.polygon;
    if (w && w.address) { this.address = w.address; this.load(); }
  },
};
</script>
